import {PhoneHQButton} from "ch3-ui-lib";
import {ArrowLeft, ArrowRight} from "lucide-react";

interface Props {
    page: number;
    totalPages: number;
    isFetching: boolean;
    onChange: (page: number) => void;
    idPrefix: string;
}

export const EnsPagination = ({page, totalPages, isFetching, onChange, idPrefix}: Props) => (
    <div className="flex items-center justify-end gap-2">
        <PhoneHQButton
            phq-id={`${idPrefix}-prevBtn`}
            size="sm"
            variant="tertiary"
            className="bg-transparent shadow-none"
            disabled={page === 0 || isFetching}
            onClick={() => onChange(Math.max(0, page - 1))}
        >
            <ArrowLeft className={'!p-0'} size={16}/>
            Previous
        </PhoneHQButton>
        <div className="text-xs text-ink-muted">
            Page {page + 1} of {totalPages}
        </div>
        <PhoneHQButton
            phq-id={`${idPrefix}-nextBtn`}
            size="sm"
            variant="tertiary"
            className="bg-transparent shadow-none"
            disabled={page + 1 >= totalPages || isFetching}
            onClick={() => onChange(page + 1)}
        >
            Next
            <ArrowRight className={'!p-0'} size={16}/>
        </PhoneHQButton>
    </div>
);
